import axios from 'axios';
import swal from "sweetalert";
import {
    loginConfirmedAction,
    Logout,
} from '../store/actions/AuthActions';

export function signUp(email, password) {
    //axios call
    const postData = {
        email,
        password,
        returnSecureToken: true,
    };
    return axios.post(
        `https://identitytoolkit.googleapis.com/v1/accounts:signUp?key=AIzaSyD3RPAp3nuETDn9OQimqn_YF6zdzqWITII`,
        postData,
    );
}

export function login(email, password) {
    const postData = {
        email,
        password,
        returnSecureToken: true,
    };
    return axios.post(
        `${process.env.REACT_APP_API_URL}/auth/login`,
        postData,
        {
            withCredentials: true // ✅ required to receive/set cookies like refreshToken
        }
    );
}
export function googlelogin(token) {
    const postData = {
        token,
    };
    return axios.post(
        `${process.env.REACT_APP_API_URL}/auth/google-login`,
        postData,
    );
}
export function microsoftlogin(idToken) {
    const postData = {
        idToken,
    };
    return axios.post(
        `${process.env.REACT_APP_API_URL}/auth/microsoft`,
        postData,
    );
}

export function generateNewToken() {
    // Get current token for authorization header
    const rememberMe = localStorage.getItem('rememberMe') === 'true';
    let token = null;
    
    if (rememberMe) {
        token = localStorage.getItem('accessToken');
    } else {
        token = localStorage.getItem('tempAccessToken');
    }
    
    const headers = {
        'Content-Type': 'application/json'
    };
    
    if (token) {
        try {
            const parsedToken = JSON.parse(token);
            headers.Authorization = `Bearer ${parsedToken}`;
        } catch (e) {
            console.error('Error parsing token for generateNewToken:', e);
        }
    }
    
    return axios.post(
        `${process.env.REACT_APP_API_URL}/auth/generate-new-token`,
        {},
        {
            headers,
            withCredentials: true // Include cookies for authentication
        }
    );
}
export function formatError(errorResponse) {
    switch (errorResponse.error.message) {
        case 'EMAIL_EXISTS':
            //return 'Email already exists';
            swal("Oops", "Email already exists", "error");
            break;
        case 'EMAIL_NOT_FOUND':
            //return 'Email not found';
            swal("Oops", "Email not found", "error", { button: "Try Again!", });
            break;
        case 'INVALID_PASSWORD':
            //return 'Invalid Password';
            swal("Oops", "Invalid Password", "error", { button: "Try Again!", });
            break;
        case 'USER_DISABLED':
            return 'User Disabled';

        default:
            return '';
    }
}

export function saveTokenInLocalStorage(tokenDetails, rememberMe, apiTimestamp = null) {
    // Use API timestamp if provided, otherwise fallback to current time
    const timestamp = apiTimestamp || Date.now();
    
    if (rememberMe) {
        // Remember Me: Store in localStorage for persistence across browser sessions
        localStorage.setItem('accessToken', JSON.stringify(tokenDetails));
        localStorage.setItem('accessTokenTimestamp', timestamp.toString());
        localStorage.setItem('rememberMe', 'true');
        // Clear any temp token
        localStorage.removeItem('tempAccessToken');
        localStorage.removeItem('tempAccessTokenTimestamp');
    } else {
        // No Remember Me: Store as temp token in localStorage for tab sharing
        localStorage.setItem('tempAccessToken', JSON.stringify(tokenDetails));
        localStorage.setItem('tempAccessTokenTimestamp', timestamp.toString());
        localStorage.setItem('rememberMe', 'false');
        // Clear regular access token
        localStorage.removeItem('accessToken');
        localStorage.removeItem('accessTokenTimestamp');
        // Mark this as the first session
        sessionStorage.setItem('isFirstSession', 'true');
        sessionStorage.setItem('accessToken', JSON.stringify(tokenDetails));
        // Set initial tab count
        sessionStorage.setItem('tabCount', '1');
    }
}
export function saveUserDataLocalStorage(userdetails) {
    localStorage.setItem('user', JSON.stringify(userdetails));
    
    // Clear subscription caches when new user logs in
    try {
        const { clearDocumentSubscriptionCache } = require('../../utils/documentAccess');
        const { clearSubscriptionCache } = require('../../utils/featureLock');
        clearDocumentSubscriptionCache();
        clearSubscriptionCache();
        // Also clear user plan features
        localStorage.removeItem('userPlanFeatures');
    } catch (err) {
        console.error('Error clearing subscription caches on login:', err);
    }
}

// Utility functions for timestamp management
export function getAccessTokenTimestamp() {
    const rememberMe = localStorage.getItem('rememberMe') === 'true';
    
    if (rememberMe) {
        const timestamp = localStorage.getItem('accessTokenTimestamp');
        return timestamp ? parseInt(timestamp) : null;
    } else {
        const timestamp = localStorage.getItem('tempAccessTokenTimestamp');
        return timestamp ? parseInt(timestamp) : null;
    }
}

export function getAccessTokenTimestampFormatted() {
    const timestamp = getAccessTokenTimestamp();
    if (!timestamp) return null;
    
    const date = new Date(timestamp);
    return {
        timestamp: timestamp,
        date: date,
        formatted: date.toLocaleString(),
        iso: date.toISOString(),
        timeAgo: getTimeAgo(timestamp)
    };
}

export function getTimeAgo(timestamp) {
    const now = Date.now();
    const diff = now - timestamp;
    
    const seconds = Math.floor(diff / 1000);
    const minutes = Math.floor(seconds / 60);
    const hours = Math.floor(minutes / 60);
    const days = Math.floor(hours / 24);
    
    if (days > 0) return `${days} day${days > 1 ? 's' : ''} ago`;
    if (hours > 0) return `${hours} hour${hours > 1 ? 's' : ''} ago`;
    if (minutes > 0) return `${minutes} minute${minutes > 1 ? 's' : ''} ago`;
    return `${seconds} second${seconds > 1 ? 's' : ''} ago`;
}

export function clearAccessTokenTimestamps() {
    localStorage.removeItem('accessTokenTimestamp');
    localStorage.removeItem('tempAccessTokenTimestamp');
}

// Check if token needs refresh based on 15-minute rule
export function shouldRefreshToken() {
    const timestamp = getAccessTokenTimestamp();
    if (!timestamp) return false;
    
    const currentTime = Date.now();
    const timeDifference = currentTime - timestamp;
    const fifteenMinutes = 15 * 60 * 1000; // 15 minutes in milliseconds
    
    return timeDifference >= fifteenMinutes;
}

// Get time difference in minutes
export function getTokenAgeMinutes() {
    const timestamp = getAccessTokenTimestamp();
    if (!timestamp) return null;
    
    const currentTime = Date.now();
    const timeDifference = currentTime - timestamp;
    return Math.floor(timeDifference / (60 * 1000)); // Convert to minutes
}

// Tab counting system for session management
export function initTabSession() {
    const rememberMe = localStorage.getItem('rememberMe') === 'true';
    console.log('initTabSession - rememberMe:', rememberMe);

    if (!rememberMe) {

        const tempToken = localStorage.getItem('tempAccessToken');
        const user = localStorage.getItem('user');

        console.log('initTabSession - tempToken found:', !!tempToken, 'user found:', !!user);

        if (tempToken && user) {
            // Copy token to sessionStorage for this new tab
            sessionStorage.setItem('accessToken', tempToken);
            // Generate unique tab ID for this tab
            const tabId = 'tab_' + Date.now() + '_' + Math.random().toString(36).substr(2, 9);
            sessionStorage.setItem('tabId', tabId);
        } else {
            console.log('No temp token or user found - this might be a fresh session');
        }
    } else {
        // For remember me users, just ensure we have the token in sessionStorage for consistency
        const accessToken = localStorage.getItem('accessToken');
        if (accessToken && !sessionStorage.getItem('accessToken')) {
            sessionStorage.setItem('accessToken', accessToken);
            console.log('Remember me - token copied to sessionStorage for new tab');
        }
    }
}

export function runLogoutTimer(dispatch, timer, navigate) {
    setTimeout(() => {
        // Store current page for redirect after login (session timeout) - only if not on login page
        const currentPath = window.location.pathname + window.location.search;
        if (currentPath !== '/login') {
            sessionStorage.setItem('redirectAfterLogin', currentPath);
        }
        dispatch(Logout(navigate));
    }, timer);
}

export function checkAutoLogin(dispatch, navigate) {
    const tokenDetailsString = localStorage.getItem('userDetails');
    let tokenDetails = '';
    if (!tokenDetailsString) {
        dispatch(Logout(navigate));
        return;
    }

    tokenDetails = JSON.parse(tokenDetailsString);
    let expireDate = new Date(tokenDetails.expireDate);
    let todaysDate = new Date();

    if (todaysDate > expireDate) {
        dispatch(Logout(navigate));
        return;
    }

    dispatch(loginConfirmedAction(tokenDetails));

}

export function restoreAuthState(dispatch) {
    return new Promise((resolve) => {
        const rememberMe = localStorage.getItem('rememberMe') === 'true';
        const user = localStorage.getItem('user');

        if (!user) {
            console.log('No user found, returning false');
            resolve(false);
            return;
        }

        let token = null;

        if (rememberMe) {
            // Remember Me: Check localStorage
            token = localStorage.getItem('accessToken');
            console.log('Remember Me - token from localStorage:', !!token);
        } else {
            // No Remember Me: Check sessionStorage first, then temp token
            token = sessionStorage.getItem('accessToken');
            console.log('No Remember Me - token from sessionStorage:', !!token);

            if (!token) {
                // No sessionStorage token, check if we have a temp token
                const tempToken = localStorage.getItem('tempAccessToken');
                if (tempToken) {
                    token = tempToken;
                    sessionStorage.setItem('accessToken', tempToken);
                    console.log('Using temp token and copied to sessionStorage');
                } else {
                    console.log('No temp token found, user needs to login');
                    resolve(false);
                    return;
                }
            }
        }

        if (!token) {
            console.log('No token found, returning false');
            resolve(false);
            return;
        }

        try {
            const parsedToken = JSON.parse(token);
            const parsedUser = JSON.parse(user);

            // Check if token is expired
            if (parsedToken && parsedToken.exp) {
                const currentTime = Math.floor(Date.now() / 1000);
                if (parsedToken.exp < currentTime) {
                    console.log('Token is expired, clearing auth data');
                    localStorage.removeItem('accessToken');
                    localStorage.removeItem('tempAccessToken');
                    sessionStorage.removeItem('accessToken');
                    localStorage.removeItem('user');
                    localStorage.removeItem('rememberMe');
                    localStorage.removeItem('tabCount');
                    resolve(false);
                    return;
                }
            }

            console.log('Successfully parsed token and user, dispatching login action');

            // Dispatch login action to restore state
            dispatch({
                type: '[login action] confirmed login',
                payload: {
                    token: parsedToken,
                    user: parsedUser
                }
            });

            resolve(true);
        } catch (error) {
            console.error('Error restoring auth state:', error);
            // Clear invalid data
            localStorage.removeItem('accessToken');
            localStorage.removeItem('tempAccessToken');
            sessionStorage.removeItem('accessToken');
            localStorage.removeItem('user');
            localStorage.removeItem('rememberMe');
            resolve(false);
        }
    });
}
